import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { RefreshPeriodService } from 'app/core/services/refresh-period.service';
import { RefreshService } from 'app/core/services/refresh.service';

@Component({
  selector: 'dialog-delete-year',
  templateUrl: './dialog-delete-year.component.html',
  styleUrls: ['./dialog-delete-year.component.scss']
})
export class DialogDeleteYearComponent implements OnInit {
  isLoading: boolean = false;
  
  constructor(public dialogRef: MatDialogRef<DialogDeleteYearComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
              private payrollDefinitionService: PayrollDefinitionService,
              private refreshService: RefreshService,
              private refreshPeriodService: RefreshPeriodService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteYear() {
    this.isLoading = true;
    this.payrollDefinitionService.deleteYear(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dialogRef.close();
        this.refreshService.emitRefresh(this.data.index);
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }

  deleteSelectedPeriod() {
    this.isLoading = true;
    this.payrollDefinitionService.deletePeriod(this.data.selectedIds).subscribe({
      next: (res) => {
        this.refreshPeriodService.emitRefresh(this.data.selectedIds);
        Promise.resolve().then(() => {
          this.isLoading = false;
          this.dialogRef.close();
        });
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting periods:', err);
        alert('Failed to delete selected periods.');
      },
    });
  }
}
